const accordionConfig = {
    groupClass: '.accordion-list',
    contentWrapper: 'accordion__content-wrapper',
    content: 'accordion__content',
    openClass: 'accordion--open',
};

export function toggleAccordion(button, config = accordionConfig) {
    const accordionComponent = button.parentElement;

    if (accordionComponent.classList.contains(config.openClass)) {
        closeAccordion(accordionComponent, button);
        return;
    }

    const accordionGroup = button.closest(accordionConfig.groupClass);

    let accordionComponentOpen = accordionGroup.querySelector(`.${config.openClass}`);
    if (accordionComponentOpen) {
        closeAccordion(accordionComponentOpen, button);
    }
    openAccordion(accordionComponent, button);
}

function closeAccordion(element, button, config = accordionConfig) {
    const accordionContentWrapper = element.querySelector(`.${config.contentWrapper}`);
    button.setAttribute('aria-expanded', false);
    accordionContentWrapper.setAttribute('aria-hidden', 'true');
    element.classList.remove(accordionConfig.openClass);
    element.querySelector(`.${config.contentWrapper}`).style.height = '';
}

function openAccordion(element, button, config = accordionConfig) {
    const accordionContent = element.querySelector(`.${config.content}`);
    const accordionContentWrapper = element.querySelector(`.${config.contentWrapper}`);

    accordionContentWrapper.style.height = accordionContent.offsetHeight + 'px';
    accordionContentWrapper.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', true);
    element.classList.add(config.openClass);
}
